import { ApiPaginatedResponse } from '@ametista-ai/api-schema/http/types';
import { UserSchema } from '@ametista-ai/api-schema/user';
import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/stores/api/apiClient';
import { usersKeys } from './keys';

export function useAgencyUsers(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: usersKeys.list(),
    queryFn: () => {
      return apiClient.get<ApiPaginatedResponse<UserSchema>>(
        '/v1/users?limit=1000',
        undefined,
        undefined
      );
    },
    enabled: options?.enabled ?? true,
  });
}
